import {CALL_CONFIG} from "../config";

let hasReset = false;

export const callResetGuard = {
  canReset() { return !hasReset; },
  markReset() { hasReset = true; },
  reset() { hasReset = false; }
};

export const callHardReset = (reason = 'call_ended') => {
  const enabled = CALL_CONFIG.HARD_RESET_ENABLED;
  if (!enabled) return;

  if (!callResetGuard.canReset()) {
    console.warn('[CallReset] ⛔ Already reset');
    return;
  }

  callResetGuard.markReset();
  console.log(`[CallReset] 🔄 Hard reset: ${reason}`);

  setTimeout(() => {
    window.location.reload();
  }, CALL_CONFIG.HARD_RESET_DELAY);
};